import StorageService from '@/services/storage-service'
import InstagramReplyApi from '@/api/instagram/reply'

export default {
  namespaced: true,
  state: {
    currentAccountId: StorageService.getItem('bya3com_insta_account', null),
    accounts: [],
    fetchedSettings: {},
    templates: [],
    templatesFetched: false,
    dependenciesFetched: false,
    webviewForms: [],
    postForm: {
      caption: '',
      files: [],
      reply_message: '',
      schedule_type: 'now',
      schedule_time: '',
      template_id: '',
    },
    edit: false,
  },
  getters: {
    accounts: (state: any) => state.accounts ?? [],
    templates: (state: any) => (Array.isArray(state.templates) ? state.templates : []),
    currentAccountId: (state: any) => state.currentAccountId,
    fromEdit: (state: any) => state.fromEdit,
    templatesFetched: (state: any) => state.templatesFetched,
    webviewForms: (state: any) => state.webviewForms,
    postForm: (state: any) => state.postForm,
    isAccountHasFeature: (state: any, getters: any) => (feature: string) => getters.currentAccount?.[feature] ?? false,
    currentAccount: (state: any) => state.accounts.find((account: any) => account.id === state.currentAccountId) ?? {},
    /** Same pool rule as FB pageCanUseApi: new_app + sum(ai_replies) vs account ai_limit. */
    accountCanUseApi: (state: any, getters: any) => {
      const a = getters.currentAccount
      if (a.ai_enabled === false) return false
      return !!a?.can_use_api
    },
  },
  mutations: {
    SET_INSTA_ACCOUNTS(state: any, accounts: Array<any>) {
      state.accounts = accounts
      if (!state.currentAccountId || !accounts.find(b => b.id === state.currentAccountId)) {
        state.currentAccountId = accounts[0]?.id
      }
    },
    SET_INSTA_ACCOUNT(state: any, accountId: number) {
      state.currentAccountId = accountId
    },
    SET_FETCHING_SETTINGS(state: any, accountId: number) {
      state.fetchedSettings[accountId] = true
    },
    RESET(state: any) {
      state.fetchedSettings = {}
    },
    SET_TEMPLATES(state: any, templates: any) {
      state.templates = Array.isArray(templates)
        ? templates
        : (templates?.data ?? templates?.templates ?? [])
    },
    SET_TEMPLATES_FETCHED(state: any, payload: any) {
      state.templatesFetched = payload
    },
    SET_POST_FORM(state: any, payload: any) {
      state.postForm = payload
    },
    SET_FROM_EDIT(state: any) {
      state.edit = true
    },
    SET_DEPENDENCIES(state: any, payload: any) {
      const { forms, templates } = payload
      state.webviewForms = forms
      state.templates = Array.isArray(templates)
        ? templates
        : (templates?.data ?? templates?.templates ?? [])
      state.dependenciesFetched = true
      state.templatesFetched = true
    },
    SET_DEPENDENCIES_FETCHED(state: any, payload: boolean) {
      state.dependenciesFetched = payload
    },
  },
  actions: {
    SET_ACCOUNT(context: any, accountId: number) {
      context.commit('SET_INSTA_ACCOUNT', accountId)

      if (!context.rootGetters['auth/impersonate']) {
        StorageService.setItem('bya3com_insta_account', accountId)
      }
    },
    async GET_DEPENDENCIES(context: any, force = false) {
      if (context.state.dependenciesFetched && !force) return
      await InstagramReplyApi.dependencies().then((data: any) => {
        context.commit('SET_DEPENDENCIES', data)
      }).catch(e => {
        throw e
      })
    },
    async GET_TEMPLATES(context: any, force = false) {
      if (context.state.templatesFetched && !force) return
      await InstagramReplyApi.templatesList().then((data: any) => {
        const templates = Array.isArray(data.templates)
          ? data.templates
          : (data.templates?.data ?? [])
        context.commit('SET_TEMPLATES', templates)
        context.commit('SET_TEMPLATES_FETCHED', true)
      }).catch(() => {
      })
    },
    async GET_ACCOUNTS(context: any) {
      return context.getters.accounts.length
    },
  },
  UPDATE_ACCOUNT(context: any, page: any) {
    const pageIdx = context.state.accounts.findIndex((b: any) => b.id === page.id)
    const pages = [...context.state.accounts]
    if (pageIdx >= 0) {
      pages[pageIdx] = {
        ...pages[pageIdx],
        ...page,
      }
    } else {
      pages.push(page)
    }
    context.commit('SET_INSTA_ACCOUNTS', pages)
    return page
  },
}
